import { aquireSession } from "./session.js";

async function main() {
    const StateP = import("./state.js").then((m) => m.State);
    const token_id = await aquireSession();
    const listP = import("./list.js").then((m) => m.TicketList);
    const State = await StateP;
    const stateP = State.create(token_id);
    const TicketList = await listP;
    const list = new TicketList();
    while (document.body.lastChild) {
        document.body.removeChild(document.body.lastChild);
    }
    document.body.appendChild(list);
    const state = await stateP;
    list.ticketState = state;
}

main().catch((e) => console.error(e));
